import React from 'react';

const CuboidAnnotationIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg style={{ width: '100%', display: 'block' }} viewBox="0 0 87 87" {...props}>
    <g fillRule="nonzero" fill="none">
      <rect
        fill={props.color || '#3CC0A7'}
        transform="rotate(-180 43.471 43.697)"
        x={0.171}
        y={0.397}
        width={86.6}
        height={86.6}
        rx={43.3}
      />
      <g fill="#FFF">
        <path
          opacity={0.5}
          d="M20.03 30.17l23.44-13.54L66.9 30.17v27.06L43.47 70.76 20.03 57.23V30.17z"
        />
        <path
          d="M66.9 30.17l-11.72 6.77v.01-.01l-11.72-6.77-11.72 6.76-11.72-6.77v27.06h.01-.01l23.44 13.53h-.01.01v-.02.02L66.9 57.22h-.01.01V30.17zm-11.71 20.3l-11.72 6.77-11.72-6.77 11.72-6.76 11.72 6.76z"
          opacity={0.5}
        />
        <path
          d="M55.18 36.93v13.53l-11.72-6.77V30.16l11.72 6.77zM31.74 50.47V36.94l-11.72-6.77v27.06h.01-.01l23.44 13.53h-.01.01V57.23l-11.72-6.76z"
          opacity={0.9}
        />
      </g>
    </g>
  </svg>
);

export default CuboidAnnotationIcon;
